var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.showContactOfferPopup ? _c('PopupContactOffer', {
    on: {
      "close": function ($event) {
        return _vm.SET_SHOW_CONTACT_OFFER_POPUP(false);
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
  }, [_vm._m(0), _vm._v(" "), _c('illustration', {
    staticClass: "hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72",
    attrs: {
      "name": "Group189"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col mt-16 mb-16"
  }, [_c('MessageHeader', {
    attrs: {
      "message-header": _vm.messageHeader
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "-my-2 py-2"
  }, [_c('div', {
    staticClass: "relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
  }, [_c('router-view')], 1)])], 1)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "px-12"
  }, [_c('p', {
    staticClass: "text-4xl text-gray-900"
  }, [_vm._v("\n        Les offres Neopass\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600"
  }, [_vm._v("\n        Retrouvez ici les différents abonnements Neopass.\n      ")])]);

}]

export { render, staticRenderFns }